<template>
  <a-button type="primary" class="m-b-15" v-has:imgNoticeAdd="()=>{$router.push('/brandMsg/announcement/imgNoticeAdd?type=add')}">
    <PlusOutlined/>添加广告
  </a-button>
  <a-form layout='inline' :model="search">
    <a-form-item label="添加时间">
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item label="显示状态">
      <a-select v-model:value="search.status" style="width:120px">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">显示</a-select-option>
        <a-select-option :value="0">隐藏</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="通知对象">
      <a-select v-model:value="search.send_type" style="width:120px">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">全部品牌</a-select-option>
        <a-select-option :value="2">指定品牌</a-select-option>
        <a-select-option :value="3">部分不可见</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click="onSearch()">搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='pagination' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list' class="m-t-20" @change="changePage">
    <template #image="{record}">
      <img :src="info.picdomain+record.image" alt="" style="width:100px;">
    </template>
    <template #sort="{record}">
      <div class="s_shou" v-has:imgNoticeSort="()=>{storVisible=true;listItem=JSON.parse(JSON.stringify(record))}">
        {{record.sort}}
        <FormOutlined />
      </div>
    </template>
    <template #status="{record}">
      <a-switch v-model:checked="record.status" v-authAction:imgNoticeStatus="()=>{onChangeStatus(record)}"
        checked-children="显示" un-checked-children="隐藏" :checkedValue="1" :unCheckedValue="0" />
    </template>
    <template #action="{record}">
      <div class="s_flex_ail">
        <a-button size="small" type="primary"
          v-has:imgNoticeEdit="()=>{$router.push('/brandMsg/announcement/imgNoticeEdit?type=edit&id='+record.id)}">编辑
        </a-button>
        <a-button size="small" type="primary" class="m-l-15" danger v-has:imgNoticeDel="()=>delAnnouncement(record)">
          删除</a-button>
      </div>
    </template>
  </a-table>
  <a-modal title="设置排序" centered v-model:visible="storVisible" :confirm-loading="bntLoading" @ok="confirmSetSort" destroyOnClose :width='400'>
    <a-input-number style='width:100%' placeholder="请输入排序" v-model:value="listItem.sort" :min='0' :max="999" :precision='0'/>
  </a-modal>

</template>
<script>
  import { noticeImgList, noticeImgDel, noticeImgStatus,noticeImgSort } from '@/api/brand.js'
  import { reactive, toRefs, ref, inject, onMounted } from 'vue';
  import { $iscode } from '@/utils/app';
  import { message } from 'ant-design-vue';
  import { FormOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import store from "@/store";
  const columns = [
    {
      title: "图片",
      dataIndex: "image",
      slots: { customRender: 'image' },
    },
    {
      title: "链接",
      dataIndex: "url",
      customRender: function ({ record }) {
        return record.url ? record.url : '-'
      }
    },
    {
      title: "通知对象",
      dataIndex: "send_type_text",
    },
    {
      title: "排序",
      dataIndex: "sort",
      slots: { customRender: 'sort' },
    },
    {
      title: "显示状态",
      dataIndex: "status",
      slots: { customRender: 'status' },
    },
    {
      title: "添加时间",
      dataIndex: "create_time",
      customRender: function ({ record }) {
        return record.create_time ? record.create_time : '-'
      }
    },
    {
      title: "操作",
      dataIndex: "action",
      slots: { customRender: 'action' },
      width: 150
    },
  ]
  export default {
    components: {
      FormOutlined,PlusOutlined
    },
    setup() {
      const $Modal = inject("$Modal");
      const search = ref({
        status: '',
        start_time: '',
        end_time: '',
        page: 1,
        limit: 10,
        send_type:""
      })
      const state = reactive({
        info: store.state.user.info,
        time: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20', '25'],
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条`,
        },
        listLoading: false,
        list: [],
        storVisible:false,
        bntLoading:false,
        listItem:{}
      })
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      // 设置排序
      const confirmSetSort = async () => {
        if(!isNumber(state.listItem.sort)){
          message.error('请输入排序值！')
          return
        }
        state.bntLoading = true;
        let result = await noticeImgSort( { id: state.listItem.id, sort: state.listItem.sort, }).then((res) => res.data).catch((error) => error);
        if ($iscode(result, true)) {
          methods.getNoticeList()
        }
        state.storVisible = false;
        state.bntLoading = false;
      }
      //修改状态
      const onChangeStatus = async (data) => {
        let result = await noticeImgStatus( { id: data.id, status: data.status, }).then((res) => res.data).catch((error) => error);
        if ($iscode(result, true)) {
          methods.getNoticeList()
        }
      }
      const methods = {
        onChange(e) {
          state.time = e;
          search.value.start_time = e[0];
          search.value.end_time = e[1];
        },
        changePage(e) {
          search.value.limit = e.pageSize;
          search.value.page = e.current;
          state.pagination.current = e.current;
          state.pagination.pageSize = e.pageSize;
          methods.getNoticeList();
        },
        
        delAnnouncement(record) {
          $Modal.confirm({
            title: '提示',
            content: '确定要删除该图片广告？',
            centered:true,
            onOk: async function () {
              const hide = message.loading('加载中...')
              let res = await noticeImgDel({ id: record.id }).then(res => res.data).catch((error) => error);
              setTimeout(hide)
              if ($iscode(res)) {
                methods.getNoticeList();
              }else {
                message.error(res.msg)
              }
            }
          })
        },
        async getNoticeList() {
          state.listLoading = true;
          state.list = [];
          let res = await noticeImgList({ ...search.value }).then(res => res.data);
          state.listLoading = false;
          if ($iscode(res)) {
            state.list = res.data.data || [];
            state.pagination.current = res.data.current_page;
            search.value.page = res.data.current_page || 1;
            state.pagination.total = res.data.total || 0;
          } else {
            message.error(res.msg)
          }
        },
        onSearch() {
          search.value.page = 1;
          methods.getNoticeList();

        }
      }

      onMounted(() => {
        methods.getNoticeList()
      })
      return {
        ...toRefs(state),
        search,
        ...methods,
        columns,
        confirmSetSort,
        onChangeStatus
      }
    },
  }
</script>